<template>
  <div class="l-page l-page--message">
    <page-sidebar />
    <main class="l-main l-main-result-message">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">リマインダープッシュの成果一覧</div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <div class="p-message-search">
            <form @submit.prevent="onSearchIconClick($event)">
              <div class="p-message-search-keyword search-toolbar">
                <button
                  :class="{ 'is-active': isDisplayCondition }"
                  class="c-btn c-btn--gray u-w120 u-h32 u-fs--s"
                  type="button"
                  @click="onClickDisplayCondition"
                >
                  <p class="c-btn__text">表示項目</p>
                </button>
                <div class="search-toolbar__right">
                  <div class="c-checkbox reminder-search-status">
                    <div class="c-checkbox__title">配信状況</div>
                    <ul class="c-checkbox-list">
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="deliverFlags" type="checkbox" :value="1" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">配信中</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="deliverFlags" type="checkbox" :value="0" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">停止中</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="c-input search-input">
                    <input
                      v-model="pushName"
                      class="c-input__item c-input__item--overlay-ico"
                      type="text"
                      placeholder="リマインダーID・タイトル・メッセージで検索"
                    />
                    <div class="c-input__icon c-input__icon--overlay" @click="onSearchIconClick($event)">
                      <div class="c-icon c-icon--white u-wh30">
                        <svg
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <use xlink:href="/assets/img/sprite.svg#search" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="p-message-search-condition display-items-panel" :class="{ 'is-active': isDisplayCondition }">
                <div class="c-title u-w1200">
                  <div class="c-title__text u-fs22">表示項目の変更</div>
                </div>
                <div class="p-message-search-condition__row">
                  <div class="c-checkbox u-w800">
                    <ul class="c-checkbox-list display-items-list">
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.reminderId" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">リマインダーID</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.message" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">配信メッセージ</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.deliverCount" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">配信通数</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.condition" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">配信条件</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.workingTime" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">配信時間帯</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.deliverStatus" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">配信状況</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.displayCount" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">表示数</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.clickCount" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">クリック</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-checkbox-list__item">
                        <label class="c-checkbox__label">
                          <input v-model="displayItems.ctr" type="checkbox" :value="true" />
                          <div class="c-checkbox__item">
                            <div class="c-checkbox__box"></div>
                            <div class="c-checkbox__box-label">CTR</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            class="p-message-result__data"
            :class="{ 'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }"
          >
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">リマインダープッシュの成果が存在しません</div>
            </div>
            <div class="result-table-wrap">
              <table class="c-table result-table">
                <thead>
                  <tr>
                    <th v-if="displayItems.reminderId" class="c-table__cell--center is-sortable col-id">
                      <span class="c-table__text">リマインダーID</span>
                      <sort-switch
                        name="messageId"
                        :order="sortTargets.messageId"
                        @on-click="onClickSortButton($event)"
                      />
                    </th>
                    <th v-if="displayItems.message" class="c-table__cell--center col-msg">
                      <span class="c-table__text">配信メッセージ</span>
                    </th>
                    <th v-if="displayItems.deliverCount" class="c-table__cell--center col-count">配信通数</th>
                    <th v-if="displayItems.condition" class="c-table__cell--center col-condition">配信条件</th>
                    <th v-if="displayItems.workingTime" class="c-table__cell--center col-time">配信時間帯</th>
                    <th v-if="displayItems.deliverStatus" class="c-table__cell--center col-status">配信状況</th>
                    <th v-if="displayItems.displayCount" class="c-table__cell--center col-impression">表示数</th>
                    <th v-if="displayItems.clickCount" class="c-table__cell--center col-click">クリック</th>
                    <th v-if="displayItems.ctr" class="c-table__cell--center col-ctr">CTR</th>
                  </tr>
                </thead>

                <reminder-message-result-list-item
                  v-for="(summaryMessage, index) in summaryMessages.data"
                  :key="index"
                  :summary-message="summaryMessage"
                  :default-icon-url="parsedMessageInfo.defaultIconUrl"
                  :display-items="displayItems"
                  @show-click="onShowMessage"
                />
              </table>
            </div>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <error-modal :is-active="isError" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

// v1 配信条件サマリ追従のため旧キーを破棄して新デフォルトを強制するためのバージョン付きキー
var STORAGE_KEY = 'reminderResultDisplayItems.v1';

export default {
  props: {
    csrfToken: String,
    messageInfo: [Object, String],
  },
  data() {
    return {
      summaryMessages: [],
      deliverFlags: [],
      pushName: null,

      sortTargets: {
        messageId: -1,
      },
      currentSortTarget: null,
      currentSortOrder: null,

      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      isDisplayCondition: false,

      displayItems: {
        reminderId: true,
        message: true,
        deliverCount: true,
        // v1 配信条件サマリは初期表示から見えるようにする(旧仕様ではチェックでのみ開示していた)
        condition: true,
        workingTime: false,
        deliverStatus: true,
        displayCount: true,
        clickCount: true,
        ctr: true,
      },

      paginationInfo: null,
      page: 1,
      searchConditionCache: null,
    };
  },
  computed: {
    parsedMessageInfo: function () {
      if (typeof this.messageInfo === 'string') {
        return JSON.parse(this.messageInfo);
      }
      return this.messageInfo;
    },
  },
  watch: {
    deliverFlags: function () {
      this.page = 1;
      this.loadData();
    },
    displayItems: {
      handler: function (newVal) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newVal));
      },
      deep: true,
    },
  },
  mounted: function () {
    var saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      var parsed = JSON.parse(saved);
      for (var key in this.displayItems) {
        if (Object.prototype.hasOwnProperty.call(parsed, key)) {
          this.displayItems[key] = parsed[key];
        }
      }
    }

    import('../../funcs/pages/message').then((module) => {
      module.Message();
      this.loadData();
    });
  },
  methods: {
    loadData: function (useCache) {
      useCache = useCache || false;

      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if (this.sortTargets[workTarget] != 0) {
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      let params = {
        params: {
          pushName: this.pushName,
          deliverFlags: this.deliverFlags,
          sort: sortTarget,
          order: order,
          page: this.page,
        },
      };

      if (useCache) {
        params = JSON.parse(JSON.stringify(this.searchConditionCache));
        params.params.page = this.page;
      } else {
        this.searchConditionCache = params;
      }

      this.isLoading = true;
      this.isLoaded = false;

      axios
        .get('/api/reminder/summary/by-message', params)
        .then((res) => {
          this.summaryMessages = res.data.items;
          this.paginationInfo = res.data.items;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            if (res.data.items.data.length < 1) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
          }, 300);
        })
        .catch((error) => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = 'リマインダー成果一覧の取得時にエラーが発生しました';
            this.isLoading = false;
          }, 300);
        });
    },

    onClickDisplayCondition: function () {
      this.isDisplayCondition = !this.isDisplayCondition;
    },

    onSearchIconClick: function (event) {
      event.preventDefault();
      this.page = 1;
      this.loadData();
    },

    onClickSortButton: function (target) {
      this.currentSortTarget = target;
      if (!this.sortTargets[target] || this.sortTargets[target] == -1) {
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if (workTarget != target) {
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    onShowMessage: function (summaryMessage) {
      location.href = '/coins-admin/reminder/result-list/' + summaryMessage.message_id;
    },

    onCloseErrorModal: function () {
      this.isError = false;
      this.errorMessage = '';
    },

    onPageClick: function (clickPage) {
      this.page = clickPage;
      this.loadData(true);
    },
  },
};
</script>

<style scoped>
@media (min-width: 1500px) {
  .l-main-result-message {
    width: calc(100% - 280px) !important;
  }
}
.result-table-wrap {
  overflow-x: auto;
  max-width: calc(100vw - 220px);
}
/*
 * 列幅は auto レイアウトを採用。
 * リマインダーID列のみ最小幅を持たせ、IDが長いほど内容に応じて自然に広がる。
 * その他の列は width と min-width を併記して固定幅で表示し、
 * ヘッダー文字や数値が折り返されないだけの十分な幅を確保する。
 */
.c-table.result-table {
  table-layout: auto;
  width: 100%;
  min-width: 1140px;
}
.col-id {
  min-width: 140px;
}
.col-msg {
  width: 200px;
  min-width: 200px;
}
.col-count {
  width: 90px;
  min-width: 90px;
}
.col-condition {
  width: 248px;
  min-width: 248px;
}
.col-time {
  width: 110px;
  min-width: 110px;
}
.col-status {
  width: 92px;
  min-width: 92px;
}
.col-impression {
  width: 90px;
  min-width: 90px;
}
.col-click {
  width: 90px;
  min-width: 90px;
}
.col-ctr {
  width: 80px;
  min-width: 80px;
}
.search-input {
  min-width: 435px;
}
.display-items-list {
  gap: 10px;
}
.search-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search-toolbar__right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.reminder-search-status {
  display: flex;
  align-items: center;
  gap: 16px;
}
.reminder-search-status .c-checkbox__title {
  margin: 0;
  padding-bottom: 0;
  white-space: nowrap;
  font-size: 13px;
}
.reminder-search-status .c-checkbox-list {
  display: flex;
  gap: 12px;
}
.reminder-search-status .c-checkbox-list__item {
  margin: 0;
}
</style>

<style>
.display-items-panel:after {
  border: 14px solid transparent;
  border-bottom: 21px solid #eef3f6;
  content: '';
  position: absolute;
  right: auto;
  left: 60px !important;
  top: -33px !important;
}
</style>
